import { useEffect } from 'react';
import type { KeenSliderInstance } from 'keen-slider/react';

type UseHorizontalWheelNavigationProps = {
    slider: KeenSliderInstance | null;
    container?: HTMLElement | null;
};

export const useHorizontalWheelNavigation = ({ slider, container }: UseHorizontalWheelNavigationProps) => {
    useEffect(() => {
        if (!slider || !container) {
            return;
        }

        let isTransitioning = false;

        const handleAnimationStart = () => {
            isTransitioning = true;
        };
        const handleAnimationEnd = () => {
            isTransitioning = false;
        };

        slider.on('animationStarted', handleAnimationStart);
        slider.on('animationEnded', handleAnimationEnd);

        const onWheel = (e: WheelEvent) => {
            if (isTransitioning) return;

            const delta = e.shiftKey
                ? e.deltaY * (e.deltaMode === WheelEvent.DOM_DELTA_LINE ? 16 : 1)
                : e.deltaX * (e.deltaMode === WheelEvent.DOM_DELTA_LINE ? 16 : 1);

            if (Math.abs(delta) < Math.abs(e.deltaY)) {
                return;
            }

            e.preventDefault();

            if (delta > 0) {
                slider.next();
            } else {
                slider.prev();
            }
        };

        container.addEventListener('wheel', onWheel, { passive: false });

        return () => {
            container.removeEventListener('wheel', onWheel);
        };
    }, [slider, container]);
};
